import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { AgencyMemberNewPage } from '@/features/agency';
import { formatDocumentTitle } from '@/lib/document-title';

export const Route = createFileRoute('/_auth/agency/members/new')({
  component: AgencyAddMemberRoute,
});

function AgencyAddMemberRoute() {
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Invite Agency Member')}</title>
      </Helmet>
      <AgencyMemberNewPage />
    </>
  );
}
